export const GET_AGENTS_SUCCESS = 'GET_AGENTS_SUCCESS';
export const SET_FILTERS = 'SET_FILTERS';
export const RESET_FILTERS = 'RESET_FILTERS';
export const SET_FETCHING_AGENTS = 'SET_FETCHING_AGENTS';